/**
 * @description 香港钱包OAuth2.0登录
 * 微信官网文档：
 * https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html
 * 登录过程：
 * html -> login.cgi?url=html  -> oauth?redirect_uri=(login.cgi?url=html)
 * -> login.cgi?url=html&code=xxxx（服务端写入cookie后重定向回到当前页面） -> html
 * 登录成功后：
 * cookie中写入包括：qluin、qlskey、refresh_token、qlappid、qq_logtype、logintime
 */
import Cookie from 'js-cookie';
import { sessionCache, localCache } from '../storage';
import { LoginApi, REDIRECT_TAG, CACHE_TIME } from './config';
// 标记已经在登录中，避免重复跳转和计数
let logging = false;
/**
 * 判断是否达到了最大重定向次数（如果最近一次重定向在1min以上，则清理次数）
 * @param max
 * @returns
 */
function isRedirectMax(max = 3) {
    // 最近一次重定向时间大于1min，则清空次数
    const cacheTime = sessionCache.getItem(CACHE_TIME);
    if (new Date().getTime() - parseInt(cacheTime, 10) > 1 * 60 * 1000) {
        sessionCache.removeItem(REDIRECT_TAG);
    }
    const redirectTag = sessionCache.getItem(REDIRECT_TAG);
    return redirectTag > max;
}
/**
 * 记录重定向次数
 */
function addRedirectTimes() {
    // 重定向次数
    let redirectTime = sessionCache.getItem(REDIRECT_TAG) || 0;
    // 重定向次数累加1
    redirectTime = redirectTime + 1;
    sessionCache.setItem(REDIRECT_TAG, redirectTime);
    // 记录当前重定向时间
    sessionCache.setItem(CACHE_TIME, new Date().getTime());
}
/**
 * 登录
 */
class Login {
    get uin() {
        return Cookie.get('qluin');
    }
    get skey() {
        return Cookie.get('qlskey');
    }
    /**
     * 判断是否登录
     * @param keys
     * @returns
     */
    checkLogin(keys = ['qluin']) {
        return keys.every(key => Cookie.get(key));
    }
    /**
     * 登录
     * 分为强制登录和可选登录
     * 强制登录：无论cookie中是否有登录信息，一律跳转登录
     * 可选登录：cookie中有登录信息，则不跳转登录
     * @param arg
     * @returns
     */
    login(arg) {
        const { scope, actId = '', url = location.href, keys = ['qluin'], force = false } = arg;
        // 非强制登录则校验cookie，通过则直接返回false
        if (!force && this.checkLogin(keys)) {
            return true;
        }
        // 重定向大于3次，则报错
        if (isRedirectMax(3)) {
            // 重定向次数大于3
            localCache.removeItem(REDIRECT_TAG);
            return false;
        }
        // 避免同一个页面多处调用登录时，错误的对重定向次数进行累加（主要场景为：页面初始化调用的多个请求都返回登录态失效的错误码）
        if (logging) {
            return true;
        }
        // 如果是高授权登录，则不需要设置
        if (!scope) {
            // 标记已经在准备跳转登录了，无需再重复发起（登录成功后的页面重定向会销毁这个变量）
            logging = true;
        }
        // 清理cookie
        // 如果是高授权登录场景，清理了cookie会导致用户点拒绝高授权后丢失登录态
        // 暂时改成：如果是高授权登录场景，则不清cookie
        // const domainTmp = domain || location.host.replace(/\w*\./, '');
        // if (domainTmp) {
        //   for (let i = 0, len = keys.length; i < len; i++) {
        //     Cookie.remove(keys[i], {
        //       domain: domainTmp,
        //     });
        //   }
        // }
        let jumpUrl = `${LoginApi}?url=${encodeURIComponent(url)}`;
        // 高授权的场景必须传scope为true和actId
        if (scope) {
            jumpUrl += '&scope=snsapi_userinfo';
        }
        if (actId) {
            jumpUrl += `&act_id=${actId}`;
        }
        // 如果是高授权登录，则不需要设置
        if (!scope) {
            // 重定向次数累加1
            addRedirectTimes();
        }
        // 跳转登录地址。需要带上#wechat_redirect来获取pass_ticket
        location.href = `${jumpUrl}#wechat_redirect`;
        return true;
    }
}
export const login = new Login();
